import { NavLink } from 'react-router'

export default function SignInLoadingSpinner({
  message,
}: {
  message?: string
}) {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-50">
      <div className="flex items-center">
        <svg
          className="h-8 w-8 animate-spin text-indigo-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"></path>
        </svg>
        <span className="ml-3 text-lg font-medium text-gray-700">
          {message || 'Signing you in, please wait...'}
        </span>
      </div>
      <div className="mt-4">
        <NavLink
          to="/"
          className="text-sm font-semibold text-indigo-600 hover:text-indigo-500">
          Takes too long? Go back to main page
        </NavLink>
      </div>
    </div>
  )
}
